<div mat-dialog-title>
  <div>{{ this.data.title }}</div>
  <div class="close-icon-container" (click)="onNoClick()">
    <fa-icon [icon]="['far', 'xmark']" class="gray"></fa-icon>
  </div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content>
  <form [formGroup]="dialogForm">
    @for (field of data.fields | keyvalue: keepOriginalOrder; track field.key) {
      @if (field.value.inputType === 'string' || field.value.inputType === 'textarea') {
        <mat-form-field class="full-width" subscriptSizing="dynamic">
          <mat-label>{{ field.value.label }}</mat-label>
          @if (field.value.inputType === 'string') {
            <input [formControlName]="field.key" [attr.data-cy]="field.key" matInput type="text" />
          } @else {
            <textarea [formControlName]="field.key" [attr.data-cy]="field.key" matInput rows="3"></textarea>
          }
          @if (dialogForm.controls[field.key].errors?.pattern) {
            <mat-error>{{ field.value.patternErrorText }}</mat-error>
          }
          @if (dialogForm.controls[field.key].errors?.required) {
            <mat-error>This field is required</mat-error>
          }
        </mat-form-field>
      }
    }
  </form>
</div>
<div mat-dialog-actions>
  <button data-cy="button-cancel" mat-stroked-button color="primary" [mat-dialog-close]="false">Cancel</button>
  <button
    data-cy="button-submit"
    mat-raised-button
    color="primary"
    [disabled]="dialogForm.invalid"
    (click)="onSubmit()">
    Submit
  </button>
</div>
